/** Must match NOTIF_CATEGORY in api-restful-node equityMarketCommsService */
export const EQUITY_MARKET_NOTIFICATION_CATEGORY = 'EQUITY_MARKET';
